import React, { useState, useEffect, useMemo, useRef } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import IconButton from "@mui/material/IconButton";
import axios from "../../../../axios-order";
import classes from "./assignServices.module.css";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";

import { ValidatorForm } from "react-material-ui-form-validator";
import DatePicker from "../../../../components/ui/DatePicker";
import { toast } from "react-toastify";

import TextField from "@material-ui/core/TextField";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";

const ServicesTable = (props) => {
  const form = useRef();
  const [dataForTable, setDataForTable] = useState([]);
  const [isRowUpdated, setIsRowUpdated] = useState(false);
  const [isLoadding, setIsLoading] = useState(false);
  const [errorForToDate, setErrorForToDate] = useState([]);
  const [mdmData, setMdmData] = useState(null);
  const [mdmFiltersToUpdate, setMdmFiltersToUpdate] = useState(null);
  const [masterFromDate, setMasterFromDate] = useState(null);
  const [masterToDate, setMasterToDate] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [selectAllReminder, setSelectAllReminder] = useState(false);
  const [masterToDateError, setMasterToDateError] = useState(null);

  const getService = () => {
    axios
      .get(
        `/cws_services/get_entity_services/${localStorage.getItem(
          "business_mgmt_entity_id"
        )}`
      )
      .then((res) => {
        setDataForTable(res.data.services_list);
      });

    axios
      .get(`/get_mdm_filters_service/${localStorage.getItem("business_mgmt_entity_id")}`)
      .then((res) => {
        setMdmData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getService();
  }, []);

  // Handle master from date change
  const handleMasterFromDate = (date) => {
    setMasterFromDate(date);
    if (date && date !== "Invalid Date") {
      const pad = "00";
      const yy = date.getFullYear().toString();
      const mm = (date.getMonth() + 1).toString();
      const dd = date.getDate().toString();
      const formattedDate = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;

      // Apply to all active sub-services
      const updatedData = dataForTable.map((service) => ({
        ...service,
        sub_service: service.sub_service.map((sub) =>
          sub.status ? { ...sub, from_date: formattedDate } : sub
        ),
      }));
      setDataForTable(updatedData);
      setIsRowUpdated(!isRowUpdated);
    }
  };

  // Handle master to date change
  const handleMasterToDate = (date) => {
    setMasterToDate(date);
    if (date && date !== "Invalid Date") {
      const pad = "00";
      const yy = date.getFullYear().toString();
      const mm = (date.getMonth() + 1).toString();
      const dd = date.getDate().toString();
      const formattedDate = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;

      if (masterFromDate && masterFromDate !== "Invalid Date") {
        const fyy = masterFromDate.getFullYear().toString();
        const fmm = (masterFromDate.getMonth() + 1).toString();
        const fdd = masterFromDate.getDate().toString();
        const formattedFromDate = `${fyy}-${(pad + fmm).slice(-2)}-${(pad + fdd).slice(-2)}`;

        if (formattedDate < formattedFromDate) {
          setMasterToDateError("To Date should not be less than From Date");
          return; 
        }
      }

      setMasterToDateError(null);
      const updatedData = dataForTable.map((service) => ({
        ...service,
        sub_service: service.sub_service.map((sub) =>
          sub.status ? { ...sub, to_date: formattedDate } : sub
        ),
      }));
      setDataForTable(updatedData);
      setIsRowUpdated(!isRowUpdated);
    }
  };

  // Handle select all status checkbox
  const handleSelectAllStatus = (e) => {
    const isChecked = e.target.checked;
    setSelectAllStatus(isChecked);

    // Format the master dates if they exist
    let formattedFromDate = null;
    let formattedToDate = null;

    if (masterFromDate && masterFromDate !== "Invalid Date") {
      const pad = "00";
      const yy = masterFromDate.getFullYear().toString();
      const mm = (masterFromDate.getMonth() + 1).toString();
      const dd = masterFromDate.getDate().toString();
      formattedFromDate = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
    }

    if (masterToDate && masterToDate !== "Invalid Date") {
      const pad = "00";
      const yy = masterToDate.getFullYear().toString();
      const mm = (masterToDate.getMonth() + 1).toString();
      const dd = masterToDate.getDate().toString();
      formattedToDate = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
    }

    // Apply to all sub-services
    const updatedData = dataForTable.map((service) => ({
      ...service,
      isSelected: isChecked,
      sub_service: service.sub_service.map((sub) => ({
        ...sub,
        status: isChecked,
        from_date: isChecked && formattedFromDate ? formattedFromDate : sub.from_date,
        to_date: isChecked && formattedToDate ? formattedToDate : sub.to_date,
      })),
    }));
    setDataForTable(updatedData);
    setIsRowUpdated(!isRowUpdated);
  };

  // Handle select all reminder checkbox
  const handleSelectAllReminder = (e) => {
    const isChecked = e.target.checked;
    setSelectAllReminder(isChecked);

    // Apply to all sub-services
    const updatedData = dataForTable.map((service) => ({
      ...service,
      sub_service: service.sub_service.map((sub) => ({
        ...sub,
        reminder: isChecked,
      })),
    }));
    setDataForTable(updatedData);
    setIsRowUpdated(!isRowUpdated);
  };

  // Handle individual row checkbox
  const handleRowCheckbox = (serviceIndex, isChecked) => {
    const updatedData = [...dataForTable];
    updatedData[serviceIndex].isSelected = isChecked;
    
    // Format the master dates if they exist
    let formattedFromDate = null;
    let formattedToDate = null;

    if (masterFromDate && masterFromDate !== "Invalid Date") {
      const pad = "00";
      const yy = masterFromDate.getFullYear().toString();
      const mm = (masterFromDate.getMonth() + 1).toString();
      const dd = masterFromDate.getDate().toString();
      formattedFromDate = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
    }

    if (masterToDate && masterToDate !== "Invalid Date") {
      const pad = "00";
      const yy = masterToDate.getFullYear().toString();
      const mm = (masterToDate.getMonth() + 1).toString();
      const dd = masterToDate.getDate().toString();
      formattedToDate = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
    }
    
    // Update all sub-services for this row
    updatedData[serviceIndex].sub_service = updatedData[serviceIndex].sub_service.map((sub) => ({
      ...sub,
      status: isChecked,
      reminder: isChecked,
      from_date: isChecked && formattedFromDate ? formattedFromDate : sub.from_date,
      to_date: isChecked && formattedToDate ? formattedToDate : sub.to_date,
    }));
    
    setDataForTable(updatedData);
    
    // Update select all status checkbox state
    const allSelected = updatedData.every(service => service.isSelected);
    setSelectAllStatus(allSelected);
    setIsRowUpdated(!isRowUpdated);
  };

  const tableHeader = () => {
    const header = [
      "Details",
      "Category",
      "Service",
      "Total Number of Sub-Service",
      "Select",
    ];
    return header.map((v) => {
      return <th>{v}</th>;
    });
  };

  const rowData = (item) => {
    let finalData = dataForTable.map((v, i) => {
      if (v.service === item.service) {
        v.sub_service = item.sub_service;
      }
    });
    setIsRowUpdated(!isRowUpdated);
  };

  useMemo(() => {
    setDataForTable(dataForTable);
  }, [isRowUpdated]);

  // service handler fn
  const assignServicesHandler = () => {
    let todateError = [];
    let fromDateError = [];
    dataForTable.map((item, i) => {
      dataForTable[i].sub_service.map((val, i) => {
        var from = new Date(val.from_date);
        var to = new Date(val.to_date);
        if (from > to) {
          todateError.push(val);
        }
      });
    });
    setErrorForToDate(todateError);

    setIsLoading(true);

    if (todateError.length) {
      setIsLoading(false);
    toast.error(`To Date should not be less than From Date`, {
          autoClose: 3000,
          progress: 0,
    });
      return false;
    }

    // First API call - Post entity services
    axios
      .post(`/cws_services/post_entity_services`, {
        business_entity_id: localStorage.getItem("business_mgmt_entity_id"),
        services: dataForTable,
      })
      .then((res) => {
        // Second API call - Update MDM filters if mdmFiltersToUpdate exists
        if (mdmFiltersToUpdate) {
          return axios.post(`/update_mdm_filters_service`, {
            business_entity_id: localStorage.getItem("business_mgmt_entity_id"),
          update_data: mdmFiltersToUpdate,
        });
      }
      return res;
    })
    .then((res) => {
      // Third API call - Save financial years for RECEIVABLES-26AS
      // Find if RECEIVABLES-26AS exists in any service and has financial_years
      let receivablesYears = [];
      dataForTable.forEach((service) => {
        const receivablesSub = service.sub_service.find(
          (s) => s.name === "RECEIVABLES-26AS"
        );
        if (receivablesSub && receivablesSub.financial_years) {
          receivablesYears = receivablesSub.financial_years;
        }
      });

      if (receivablesYears.length > 0) {
        return axios.post(`/save_available_years_for_auto_download`, {
          business_entity_id: localStorage.getItem("business_mgmt_entity_id"),
          available_years: receivablesYears,
          autodownload_type: "26as",
          });
        }
        return res;
      })
      .then((res) => {
        setIsLoading(false);
        toast.success("Service successfully assigned.", {
          autoClose: 3000,
          progress: 0,
        });
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        toast.error(
          "some error occurred,Please contact system administrator!",
          {
            autoClose: 3000,
            progress: 0,
          }
        );
      });
  };

  return (
    <>
      <ValidatorForm
        ref={form}
        onSubmit={assignServicesHandler}
        onError={(errors) => console.log(errors)}
      >
        <div style={{ margin: "30px" }}>
          {/* SUBSCRIPTION BLOCK */}
          <div style={{ 
            marginBottom: "20px",
            padding: "12px 16px",
            border: "2px solid #003366",
            borderRadius: "6px",
            backgroundColor: "#f8f9fa"
          }}>
            <div style={{ 
              display: "flex", 
              alignItems: "center",
              gap: "20px"
            }}>
              {/* Subscription Label on the left */}
              <div style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#003366",
                minWidth: "100px",
                textAlign: "left"
              }}>
                SUBSCRIPTION
              </div>

              {/* Controls Container */}
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "25px",
                flex: "1"
              }}>
                {/* FROM DATE */}
                <div style={{ 
                  display: "flex", 
                  flexDirection: "column", 
                  alignItems: "center", 
                  gap: "6px",
                  flex: "1"
                }}>
                  <span style={{ 
                    fontSize: "13px", 
                    fontWeight: "600",
                    textTransform: "uppercase",
                    color: "#003366"
                  }}>
                    FROM DATE
                  </span>
                  <DatePicker
                    name="master_from_date"
                    value={masterFromDate ?? ""}
                    onChange={handleMasterFromDate}
                    maxDateForDatepicker={masterToDate ? masterToDate : new Date()}
                  />
                </div>

                {/* TO DATE */}
                <div style={{ 
                  display: "flex", 
                  flexDirection: "column", 
                  alignItems: "center", 
                  gap: "6px",
                  flex: "1"
                }}>
                  <span style={{ 
                    fontSize: "13px", 
                    fontWeight: "600",
                    textTransform: "uppercase",
                    color: "#003366"
                  }}>
                    TO DATE
                  </span>
                  <DatePicker
                    name="master_to_date"
                    value={masterToDate ?? ""}
                    onChange={handleMasterToDate}
                    minDateForDatepicker={masterFromDate ? masterFromDate : new Date()}
                  />
                  {masterToDateError && (
                    <div style={{ color: "red", fontSize: "11px", marginTop: "2px" }}>
                      {masterToDateError}
                    </div>
                  )}
                </div>

                {/* STATUS */}
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "6px",
                  flex: "0 0 auto",
                  minWidth: "90px"
                }}>
                  <span style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    color: "#003366"
                  }}>
                    STATUS
                  </span>
                  <input
                    type="checkbox"
                    checked={selectAllStatus}
                    onChange={handleSelectAllStatus}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* REMINDER */}
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "6px",
                  flex: "0 0 auto",
                  minWidth: "90px"
                }}>
                  <span style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    color: "#003366"
                  }}>
                    REMINDER
                  </span>
                  <input
                    type="checkbox"
                    checked={selectAllReminder}
                    onChange={handleSelectAllReminder}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Services heading - below subscription block */}
          <div style={{ 
            fontSize: "18px", 
            fontWeight: "600", 
            marginBottom: "15px",
            marginTop: "10px",
            paddingBottom: "10px",
            borderBottom: "1px solid #ddd",
            color: "#333"
          }}>
            Services
          </div>

          {/* SERVICE TABLE */}
          <table className={classes.customeTable}>
            <thead>
              <tr>{tableHeader()}</tr>
            </thead>
            <tbody>
              {dataForTable.map((v, index) => (
                <Row
                  key={index}
                  data={v}
                  rowIndex={index}
                  setRowWiseData={rowData}
                  mdmData={mdmData}
                  setMdmFiltersToUpdate={setMdmFiltersToUpdate}
                  onRowCheckboxChange={handleRowCheckbox}
                />
              ))}

              {dataForTable.length === 0 && (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    Loading.Please wait...
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* SUBMIT BUTTON */}
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            <button
              style={{ marginRight: "0px" }}
              className="button-secondary mt-20"
              disabled={isLoadding}
            >
              {isLoadding && (
                <CircularProgress style={{ color: "#fff" }} size={20} />
              )}
              {!isLoadding && "Submit"}
            </button>
          </div>
        </div>
      </ValidatorForm>
    </>
  );
};

function Row(props) {
  const { data, rowIndex, setRowWiseData, mdmData, setMdmFiltersToUpdate, onRowCheckboxChange } = props;
  const [open, setOpen] = useState(false);
  const [isStatusUpadted, setIsStatusUpdated] = useState(false);
  const [isReminderUpadted, setIsReminderUpdated] = useState(false);
  const [isFromDateUpadted, setIsFromDateUpdated] = useState(false);
  const [isToDateUpadted, setIsToDateUpdated] = useState(false);
  const [toDateError, setToDateError] = useState({});
  const [financialYearsList, setFinancialYearsList] = useState([]);
  const [receivables26ASSelectedYears, setReceivables26ASSelectedYears] = useState(
    data.sub_service.find(s => s.name === "RECEIVABLES-26AS")?.financial_years || []
  );
  const [receivables26ASCurrentYear, setReceivables26ASCurrentYear] = useState("");
  const [mdmFilters, setMdmFilters] = useState({
    gstin: mdmData?.gstin || 0,
    pan: mdmData?.pan || 0,
    tan: mdmData?.tan || 0,
    msme: mdmData?.msme || 0,
    cin_lpin: mdmData?.cin_lpin || 0

  });

  // Check if this is the MDM service
  const isMDMService = data.service === "MASTER DATA MAINTAINANCE [MDM]";

  // Update mdmFilters when mdmData changes
  useEffect(() => {
    if (mdmData) {
      setMdmFilters({
        gstin: mdmData.gstin || 0,
        pan: mdmData.pan || 0,
        tan: mdmData?.tan || 0,
        msme: mdmData.msme || 0,
        cin_lpin: mdmData.cin_lpin || 0
      });
    }
  }, [mdmData]);

useEffect(() => {
  const year = new Date().getFullYear();
  const list = [];
  for (let i = year - 10; i <= year + 1; i++) {
    list.push({ id: `${i}-${i + 1}`, year: `${i}-${i + 1}` });
  }
  setFinancialYearsList(list);

  const hasReceivables = data.sub_service.some(s => s.name === "RECEIVABLES-26AS");
  if (hasReceivables) {
    const businessEntityId = localStorage.getItem("business_mgmt_entity_id");
    axios
      .get(`/get_available_years_for_auto_download/${businessEntityId}/26as`)
      .then((res) => {
        if (res.data.status === true && res.data.records.length > 0) {
          setReceivables26ASSelectedYears(res.data.records);
          data.sub_service = data.sub_service.map((s) =>
            s.name === "26as"
              ? { ...s, financial_years: res.data.records }
              : s
          );
        }
      })
      .catch((error) => {
        console.error("Error loading financial years:", error);
      });
  }
}, []); 

  // Update parent component's mdmFiltersToUpdate whenever mdmFilters changes
  useEffect(() => {
    if (isMDMService) {
      setMdmFiltersToUpdate(mdmFilters);
    }
  }, [mdmFilters, isMDMService]);

  useEffect(() => {
    setRowWiseData(data);
  }, [isStatusUpadted, isReminderUpadted, isFromDateUpadted, isToDateUpadted]);

  const handleMdmFilterChange = (filterName) => {
    setMdmFilters(prev => ({
      ...prev,
      [filterName]: prev[filterName] === 1 ? 0 : 1
    }));
  };

  const statusHandler = (e, item) => {
    data.sub_service.map((service) => {
      if (service.name === item.name) {
        if (e.target.checked === true) {
          service.status = true;
          service.reminder = true;
        } else {
          service.status = false;
          service.reminder = false;
        }
      }
    });
    setIsStatusUpdated(!isStatusUpadted);
  };

  const handleReceivablesYearChange = (e) => {
    const selectedYear = e.target.value;
    if (!selectedYear) return;

    if (receivables26ASSelectedYears.includes(selectedYear)) {
      setReceivables26ASCurrentYear("");
      return;
    }

    const updatedYears = [...receivables26ASSelectedYears, selectedYear];
    setReceivables26ASSelectedYears(updatedYears);
    setReceivables26ASCurrentYear("");

    // Sync into data so it gets submitted
    data.sub_service = data.sub_service.map((s) =>
      s.name === "RECEIVABLES-26AS" ? { ...s, financial_years: updatedYears } : s
    );
    setIsStatusUpdated(!isStatusUpadted);
  };

  const handleRemoveReceivablesYear = (yearToRemove) => {
    const updatedYears = receivables26ASSelectedYears.filter((y) => y !== yearToRemove);
    setReceivables26ASSelectedYears(updatedYears);

    data.sub_service = data.sub_service.map((s) =>
      s.name === "RECEIVABLES-26AS" ? { ...s, financial_years: updatedYears } : s
    );
    setIsStatusUpdated(!isStatusUpadted);
  };

  const reminderHandler = (e, item) => {
    data.sub_service.map((service) => {
      if (service.name === item.name) {
        if (e.target.checked === true) {
          service.reminder = true;
        } else {
          service.reminder = false;
        }
      }
    });
    setIsReminderUpdated(!isReminderUpadted);
  };

  const fromDateHandler = (v, item) => {
    if (v === "" || v === null) {
      data.sub_service.map((service) => {
        if (service.name === item.name) {
          service.from_date = null;
        }
      });
    } else if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      const from_date = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;

      data.sub_service.map((service) => {
        if (service.name === item.name) {
          service.from_date = from_date;
        }
      });
    }
    setIsFromDateUpdated(!isFromDateUpadted);
  };

  const toDateHandler = (v, item) => {
    if (v === "" || v === null) {
      data.sub_service.map((service) => {
        if (service.name === item.name) {
          service.to_date = null;
        }
      });
      setToDateError(prev => ({ ...prev, [item.name]: null }));
    } else if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      const to_date = `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
      if (item.from_date && to_date < item.from_date) {
        setToDateError(prev => ({ ...prev, [item.name]: "To Date should not be less than From Date" }));
        return; 
      } else {
        setToDateError(prev => ({ ...prev, [item.name]: null }));
      data.sub_service.map((service) => {
        if (service.name === item.name) {
          service.to_date = to_date;
        }
      });
      }
    }
    setIsToDateUpdated(!isToDateUpadted);
  };

  return (
    <>
      <tr>
        <td>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <DoNotDisturbOnIcon style={{ color: "black" }} />
            ) : (
              <AddCircleIcon style={{ color: "black" }} />
            )}
          </IconButton>
        </td>
        <td>{data && data.category}</td>
        <td>{data && data.service}</td>
        <td>{data && data.sub_service.length}</td>
        <td style={{ textAlign: "center" }}>
          <input
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
            }}
            type="checkbox"
            checked={data.isSelected || false}
            className="form-check-input"
            onChange={(e) => onRowCheckboxChange(rowIndex, e.target.checked)}
          />
        </td>
      </tr>

      <tr>
        <TableCell style={{ padding: "0px 20px" }} colSpan={5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography
                variant="h6"
                gutterBottom
                component="div"
                style={{ fontSize: "15px", textAlign: "left" }}
              >
                {/* Sub-Services Under this service */}
              </Typography>
              <Table
                size="small"
                aria-label="purchases"
                style={{ color: "black" }}
              >
                <thead>
                  <TableRow>
                    <th style={{}}>S NO.</th>
                    <th>Sub-Service</th>
                    <th>status(Active / Inactive)</th>
                    <th>
                      From Date<span style={{ color: "#fff" }}>*</span>
                    </th>
                    <th>
                      To Date<span style={{ color: "#fff" }}>*</span>
                    </th>
                    <th>Reminder</th>
                  </TableRow>
                </thead>
                <tbody>
                  {data.sub_service.map((value, index) => (
                    <>
                    <TableRow key={index}>
                      <td style={{ textAlign: "center", border: "none" }}>
                        {index + 1}
                      </td>
                      <td style={{ textAlign: "center", border: "none" }}>
                        {value.name}
                      </td>
                      <td style={{ textAlign: "center", border: "none" }}>
                        <input
                            style={{ width: "18px", height: "18px", position: "relative" }}
                          type="checkbox"
                          checked={value.status}
                          className="form-check-input"
                          onChange={(e) => statusHandler(e, value)}
                        />
                      </td>
                        <td style={{ textAlign: "center", padding: "0px 10px", border: "none" }}>
                        {value.status === true ? (
                          <DatePicker
                            name="from_date"
                            value={value.from_date ?? ""}
                            onChange={(v) => fromDateHandler(v, value)}
                            validators={["required"]}
                            errorMessages={["From Date is required"]}
                              maxDateForDatepicker={value.to_date ? value.to_date : new Date()}
                          />
                        ) : (
                          <TextField
                              disabled fullWidth id="outlined-disabled" size="small" variant="outlined"
                              InputProps={{ endAdornment: (<InputAdornment position="end"><InsertInvitationIcon /></InputAdornment>) }}
                          />
                        )}
                      </td>
                        <td style={{ textAlign: "center", padding: "5px 10px", border: "none" }}>
                        {value.status === true ? (
                          <>
                          <DatePicker
                            name="to_date"
                            value={value.to_date ?? ""}
                                minDateForDatepicker={value.from_date ? value.from_date : new Date()}
                            onChange={(v) => toDateHandler(v, value)}
                            validators={["required"]}
                            errorMessages={["To Date is required"]}
                          />
                            {toDateError[value.name] && (
                              <div style={{ color: "red", fontSize: "11px", marginTop: "4px" }}>
                                {toDateError[value.name]}
                              </div>
                            )}
                          </>
                        ) : (
                          <TextField
                              disabled fullWidth id="outlined-disabled" size="small" variant="outlined"
                              InputProps={{ endAdornment: (<InputAdornment position="end"><InsertInvitationIcon /></InputAdornment>) }}
                          />
                        )}
                      </td>
                      <td style={{ textAlign: "center", border: "none" }}>
                        <input
                            style={{ width: "18px", height: "18px", position: "relative" }}
                          type="checkbox"
                          checked={value.reminder}
                          className="form-check-input"
                          onChange={(e) => reminderHandler(e, value)}
                        />
                      </td>
                    </TableRow>

                      {/* ---- FINANCIAL YEAR BOX - only below RECEIVABLES-26AS ---- */}
                      {value.name === "RECEIVABLES-26AS" && (
                        <TableRow key={`fy-${index}`}>
                          {/* Empty cells to skip S.NO and SUB-SERVICE and STATUS columns */}
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }}></td>

                          {/* Box sits under FROM DATE and TO DATE columns */}
                          <td colSpan={2} style={{ border: "none", padding: "0px 10px 10px 10px" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "10px 14px",
                                border: "1px solid #1a3c5e",
                                borderRadius: "6px",
                                backgroundColor: "#f0f4f8",
                              }}
                            >
                              {/* Label */}
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#1a3c5e",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Financial Year :
                              </span>

                              {/* Dropdown */}
                              <select
                                value={receivables26ASCurrentYear}
                                onChange={handleReceivablesYearChange}
                                style={{
                                  padding: "5px 8px",
                                  borderRadius: "4px",
                                  border: "1px solid #aaa",
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  minWidth: "130px",
                                }}
                              >
                                <option value="">Select FY</option>
                                {financialYearsList.map((fy) => (
                                  <option key={fy.id} value={fy.id}>
                                    {fy.year}
                                  </option>
                                ))}
                              </select>

                              {/* Selected Year Chips */}
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                {receivables26ASSelectedYears.length === 0 ? (
                                  <span style={{ color: "#999", fontSize: "12px" }}>
                                    No years selected
                                  </span>
                                ) : (
                                  receivables26ASSelectedYears.map((year) => (
                                    <span
                                      key={year}
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        backgroundColor: "#1a3c5e",
                                        color: "#fff",
                                        borderRadius: "12px",
                                        padding: "3px 10px",
                                        fontSize: "12px",
                                        gap: "5px",
                                      }}
                                    >
                                      {year}
                                      <span
                                        onClick={() => handleRemoveReceivablesYear(year)}
                                        style={{
                                          cursor: "pointer",
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          lineHeight: "1",
                                        }}
                                      >
                                        ×
                                      </span>
                                    </span>
                                  ))
                                )}
                              </div>
                            </div>
                          </td>

                          {/* Empty cell for REMINDER column */}
                          <td style={{ border: "none" }}></td>
                        </TableRow>
                      )}
                    </>
                  ))}

                  {/* Display MDM filters as additional rows if this is MDM service */}
                  {isMDMService && mdmData && (
                    <TableRow>
                      <td colSpan={6} style={{ padding: '20px 0', border: 'none' }}>
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          padding: '10px 40px',
                          width: '100%'
                        }}>
                          {/* GSTIN */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            minWidth: '120px'
                          }}>
                            <input
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: 'pointer',
                                flexShrink: 0,
                              }}
                              type="checkbox"
                              checked={mdmFilters.gstin === 1}
                              className="form-check-input"
                              onChange={() => handleMdmFilterChange('gstin')}
                            />
                            <span style={{ fontWeight: '500', fontSize: '15px', whiteSpace: 'nowrap', marginLeft: '12px' }}>
                              GSTIN
                            </span>
                          </div>

                          {/* PAN */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            minWidth: '120px'
                          }}>
                            <input
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: 'pointer',
                                flexShrink: 0,
                              }}
                              type="checkbox"
                              checked={mdmFilters.pan === 1}
                              className="form-check-input"
                              onChange={() => handleMdmFilterChange('pan')}
                            />
                            <span style={{ fontWeight: '500', fontSize: '15px', whiteSpace: 'nowrap', marginLeft: '12px' }}>
                              PAN
                            </span>
                          </div>

                          {/* TAN */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            minWidth: '120px'
                          }}>
                            <input
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: 'pointer',
                                flexShrink: 0,
                              }}
                              type="checkbox"
                              checked={mdmFilters.tan === 1}
                              className="form-check-input"
                              onChange={() => handleMdmFilterChange('tan')}
                            />
                            <span style={{ fontWeight: '500', fontSize: '15px', whiteSpace: 'nowrap', marginLeft: '12px' }}>
                              TAN
                            </span>
                          </div>

                          {/* MSME */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            minWidth: '120px'
                          }}>
                            <input
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: 'pointer',
                                flexShrink: 0,
                              }}
                              type="checkbox"
                              checked={mdmFilters.msme === 1}
                              className="form-check-input"
                              onChange={() => handleMdmFilterChange('msme')}
                            />
                            <span style={{ fontWeight: '500', fontSize: '15px', whiteSpace: 'nowrap', marginLeft: '12px' }}>
                              MSME
                            </span>
                          </div>

                          {/* CIN/LPIN */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            minWidth: '120px'
                          }}>
                            <input
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: 'pointer',
                                flexShrink: 0,
                              }}
                              type="checkbox"
                              checked={mdmFilters.cin_lpin === 1}
                              className="form-check-input"
                              onChange={() => handleMdmFilterChange('cin_lpin')}
                            />
                            <span style={{ fontWeight: '500', fontSize: '15px', whiteSpace: 'nowrap', marginLeft: '12px' }}>
                              CIN/LPIN
                            </span>
                          </div>
                        </div>
                      </td>
                    </TableRow>
                  )}
                </tbody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </tr>
    </>
  );
}

export default ServicesTable;